/**
 * The one focus ring. A 2px brand outline, offset so it reads on both light and
 * dark surfaces. Every interactive element in the kit spreads this — never write a
 * bespoke focus style.
 */
export const focusRing =
  "outline-none focus-visible:outline-2 focus-visible:outline-offset-2 " +
  "focus-visible:outline-[color:var(--c9-border-focused)]";

/** Inset variant, for controls flush against a container edge (table rows, tabs). */
export const focusRingInset =
  "outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 " +
  "focus-visible:outline-[color:var(--c9-border-focused)]";
